import { render, staticRenderFns } from "./SurveyControl.vue?vue&type=template&id=8783c636&"
import script from "./SurveyControl.vue?vue&type=script&lang=ts&"
export * from "./SurveyControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports